import { defineStore } from 'pinia';
import api from '@/helpers/axiosConfig'
import useErrorStore from './error';
import useReceiptStore from './receipt';
import VueCookies from 'vue-cookies'

export default defineStore('auth', {
  state: () => ({
    user: null,
    loggedIn: false,
    lastAction: null,
    isLoading: false,
  }),
  actions: {
    setUserDetails (data) {
      this.user = data
      this.loggedIn = true

      // Set the oktaUser in cookies
      VueCookies.set('oktaUser', JSON.stringify(this.user), '7d'); // 7 days expiration
    },
    async getUserDetails(token) {
      try {
        this.isLoading = true
        const receiptStore = useReceiptStore()
        const res = await api.post('/users/me', {
          accessToken: token,
          customerToken: receiptStore.customerToken
        })
        
        this.setUserDetails(res.data.me)
        return res.data
      } catch (ex) {
        console.error('Failed to get user details:', ex)
        if (ex.response) {
          return ex.response.data
        } else {
          return { success: false }
        }
      } finally {
        this.isLoading = false
      }
    },
    async login(credentials) {
      try {
        this.isLoading = true
        const res = await api.post(`/users/auth`, {
          accessToken: credentials.accessToken,
          customerToken: credentials.customerToken,
          campaignId: credentials.campaignId || 'pg-youtil-ro'
        })
        
        // Get user details after successful login
        await this.getUserDetails(credentials.accessToken)
        return res.data.success
      } catch (error) {
        const errorStore = useErrorStore()
        errorStore.handleError(error)
        throw error
      } finally {
        this.isLoading = false
      }
    },
    async forgotPassword(credentials) {
      try {
        const res = await api.post(`/users/forgetPassword`, credentials)
        return res.data.success
      } catch (error) {
        const errorStore = useErrorStore()
        errorStore.handleError(error)
        throw error
      }
    },
    async updateProfile(credentials) {
      try {
        const res = await api.put(`/users/update`, credentials)
        return res.data.success
      } catch (error) {
        const errorStore = useErrorStore()
        errorStore.handleError(error)
        throw error
      }
    },
    async logout() {
      this.user = null
      this.loggedIn = false

      try {
        await api.delete(`/users/logout`)
        // Clear the oktaUser cookie
        VueCookies.remove('oktaUser')
        return true
      } catch (error) {
        const errorStore = useErrorStore()
        errorStore.handleError(error)
        throw error
      }
    }
  }
});
